// Recovered compiled webpack factory 42742. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e) {
    return "/api" === e || !!(null == e ? void 0 : e.startsWith("/api/"));
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "isAPIRoute", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
}
